import { WorkflowSsnVerification } from "../components/workflowSsn/WorkflowSsnVerification";

export function WorkflowSsnPage() {
  return <WorkflowSsnVerification />;
}
